module.exports = __webpack_public_path__ + "img/dang4.b01a88db.png";